import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";

import Select from "react-select";
import PrimaryButton from "../../../components/PrimaryButton";
import axios from "axios";
import { Icon } from "@iconify/react";
import {
  BRANDS_LIST,
  getAxiosConfig,
  MaterialBannerData,
} from "../../../utils/helpers";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import MaterialCard from "./MaterialCard";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { toast } from "react-toastify";
import { Spinner } from "@chakra-ui/react";
import useRole from "../../../utils/useRole";
import AiButton from "./sidebar/AiButton";
import FilterBar from "./FilterBar";
import SubFilterBar from "./SubFilterBar";
import ShowBrandButton from "../../../components/ShowBrandButton";
import useInfiniteScroll from "../../../hooks/useInfiniteScroll";
import AddMaterialButton from "./AddMaterialButton";

const MaterialFilter = ({ isDelete = false }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const state = location.state;
  // // console.log({ state });
  const IS_SHOW_BAR = searchParams.get("type") == "select";
  const IS_CLIENT_VIEW = IS_SHOW_BAR;
  const brand = searchParams.get("brand");
  const type = searchParams.get("type");
  const search = searchParams.get("search");
  const abortMaterialReq = useRef(null);
  const loadingTimerRef = useRef(null);
  const firstPageLoadingTimerRef = useRef(null);
  const prevFilterKeyRef = useRef(null);
  // // console.log({ location });

  const [filteredMaterials, setFilteredMaterials] = useState([]);
  const [allMaterials, setAllMaterials] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [totalProducts, setTotalProducts] = useState(20);
  const [Loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [materialPrice, setMaterialPrice] = useState({
    minPrice: null,
    maxPrice: null,
  });
  const [detailedFilter, setDetailedFilter] = useState({});
  const [refetchFilter, setRefetchFilter] = useState(false);
  const [projectPopup, setProjectPopup] = useState([false, null]);
  const [filterloading, setFilterLoading] = useState([false, null]); // isLoading, byWhom
  const [firstPageLoading, setFirstPageLoading] = useState(false);
  const [aiImageLoading, setAiImageLoading] = useState(false);

  const [zonePopup, setZonePopup] = useState([false, null]); //[isopen, materialZones]
  const [selectedZones, setSelectedZones] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isPublicView, setIsPublicView] = useState(false);
  const [aiRecommendations, setAiRecommendations] = useState(
    state?.aiRecommendations ? state?.aiRecommendations : [],
  );

  const [designData, setDesignData] = useState(
    state?.designData
      ? state?.designData
      : {
          projectId: null,
          projectName: null,
          designVibe: null,
          selectedMaterial: {},
        },
  );
  const [isViewBrand, setIsViewBrand] = useState({
    popup: false,
    authorized: !IS_SHOW_BAR,
  });
  const [filters, setFilters] = useState(
    state?.filters || {
      zone: [],
      section: [],
      material: [],
    },
  );
  const initialNewFilterValues = {
    brands: [],
    zone: [],
    search: "",
  };

  const computedFilter =
    state?.newfilter ??
    (brand
      ? { brands: [brand] }
      : type
        ? {
            brands: BRANDS_LIST.filter((v) => v?.type === type).map(
              (v) => v?._id,
            ),
          }
        : search
          ? { search }
          : {});

  const [newfilter, setNewFilter] = useState({
    ...initialNewFilterValues,
    ...computedFilter,
  });
  const [subFilter, setSubFilter] = useState({});
  const [selectedProjectImage, setSelectedProjectImage] = useState(
    state?.selectedProjectImage || null,
  );
  const bannerInfo =
    MaterialBannerData?.[
      BRANDS_LIST?.find((bran) => bran?._id == newfilter?.brands?.[0])
        ?.bannerIdx || 0
    ];
  const [areas, setAreas] = useState(state?.areas ? state?.areas : []);
  const [projectSearch, setProjectSearch] = useState("");

  async function handleAddToProject(materialId, zones) {
    // return ;
    try {
      // const data = await Promise.all(
      //   selectedProjects.map((project) =>
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/material/add-project/${materialId}`,
        { projectIds: [{ id: projectPopup?.[1]?._id, zones: zones || [] }] },
        getAxiosConfig(),
      );
      //   )
      // );
      // // console.log(data);
      // toast.success("Material added to project successfully");
      fetchMaterials();
      setZonePopup([false, null]);
      setSelectedZones([]);
    } catch (error) {
      console.error("Error adding material to project:", error);
      toast.error("Failed to add material to project");
      // You can handle the error here, e.g., show a notification
    }
  }
  useInfiniteScroll(Loading, hasMore, setCurrPage);
  const fetchMaterials = async (isAll = false) => {
    if (abortMaterialReq.current && !isAll) {
      abortMaterialReq.current.abort();
    }
    const abortController = new AbortController();
    !isAll && (abortMaterialReq.current = abortController);

    console.log("FETCHING", { filters, designData, isAll });
    const arr = designData.selectedMaterial[filters?.zone?.[0]];
    const mtype =
      newfilter?.types &&
      Array.isArray(newfilter?.types) &&
      newfilter?.types?.length
        ? newfilter?.types?.join(",")
        : "";
    let selectedIds = !!mtype
      ? Array.isArray(arr)
        ? arr.map((v) => v.materialId)
        : []
      : [];
    selectedIds = [...selectedIds];
    try {
      setLoading(true);
      if (currPage === 1) {
        setFirstPageLoading(true);
      }
      let updatedSubFilter = {};
      Object.keys(subFilter).forEach((key) => {
        if (
          subFilter[key] != null &&
          subFilter[key] !== "" &&
          !(Array.isArray(subFilter[key]) && subFilter[key].length === 0)
        ) {
          updatedSubFilter[key] = subFilter[key];
        }
      });
      const {
        data: { data },
      } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/material/get-all`,
        getAxiosConfig(
          isAll
            ? {
                page: currPage,
                materialType: mtype,
                brand:
                  newfilter?.brands &&
                  Array.isArray(newfilter?.brands) &&
                  newfilter?.brands?.length
                    ? newfilter?.brands?.join(",")
                    : "",
                search: (newfilter?.search || "")?.trim(),
                zone:
                  newfilter?.zone &&
                  Array.isArray(newfilter?.zone) &&
                  newfilter?.zone?.join(","),
                filter: JSON.stringify(updatedSubFilter),
                selectedIds: JSON.stringify(selectedIds),
                aiRecommendations: JSON.stringify(aiRecommendations),
                isDelete,
                selectedZone:
                  areas && areas.length > 0 ? areas.join(",") : null,
                ...(materialPrice.minPrice != null && {
                  minPrice: materialPrice.minPrice,
                }),
                ...(materialPrice.maxPrice != null && {
                  maxPrice: materialPrice.maxPrice,
                }),
              }
            : {
                detailedFilter,
                page: currPage,
                materialType: mtype,
                brand:
                  newfilter?.brands &&
                  Array.isArray(newfilter?.brands) &&
                  newfilter?.brands?.length
                    ? newfilter?.brands?.join(",")
                    : "",
                search: (newfilter?.search || "")?.trim(),
                zone:
                  newfilter?.zone &&
                  Array.isArray(newfilter?.zone) &&
                  newfilter?.zone?.join(","),

                filter: JSON.stringify(updatedSubFilter),
                selectedIds: JSON.stringify(selectedIds),
                aiRecommendations: JSON.stringify(
                  (aiRecommendations || []).filter(
                    (v) => !(selectedIds || []).includes(v),
                  ),
                ),
                isDelete,

                selectedZone:
                  areas && areas.length > 0 ? areas.join(",") : null,
                ...(materialPrice.minPrice != null && {
                  minPrice: materialPrice.minPrice,
                }),
                ...(materialPrice.maxPrice != null && {
                  maxPrice: materialPrice.maxPrice,
                }),
              },
          false,
          isAll ? null : abortController.signal,
        ),
      );
      if (data?.collections?.length < 20) {
        setHasMore(false);
      }
      setTotalProducts(data?.total);
      if (data?.total != 0) {
        isAll
          ? setAllMaterials((prev) => {
              const newItems = data.collections.filter(
                (item) => !prev.some((p) => p._id === item._id),
              );
              if (data.page === 1) return data.collections;
              return [
                ...(prev.length >= data.page * data.limit ? prev : prev),
                ...newItems,
              ];
            })
          : setFilteredMaterials((prev) => {
              const newItems = data.collections.filter(
                (item) => !prev.some((p) => p._id === item._id),
              );
              if (data.page === 1) return data.collections;
              return [
                ...(prev.length >= data.page * data.limit ? prev : prev),
                ...newItems,
              ];
            });
      } else {
        isAll ? setAllMaterials([]) : setFilteredMaterials([]);
      }
    } catch (error) {
      if (
        axios.isCancel(error) ||
        error?.name === "AbortError" ||
        error?.code === "ERR_CANCELED"
      ) {
        return;
      }
      console.error("Error fetching materials:", error);
    } finally {
      if (!abortController.signal.aborted || isAll) {
        setLoading(false);
        handleFilterLoading(false, "materialFilter");
        setFirstPageLoading(false);
      }
    }
  };

  function handleFilterLoading(bool, byWhom) {
    setFilterLoading([bool, byWhom]);
    return;
  }

  function handleZoneSelection(zone) {
    if (selectedZones.includes(zone)) {
      setSelectedZones((prev) => prev.filter((v) => v !== zone));
    } else {
      setSelectedZones((prev) => [...prev, zone]);
    }
  }
  // console.log({ designData, filters });
  const handleAddMaterialToProject = useCallback(
    (id, quantity = 1, material, uom = "") => {
      if (filters.zone.length === 0 || filters.section.length === 0 || !id)
        return;
      try {
        // // console.log('id', id);
        const zone = filters.zone[0];
        const section = filters.section[0];
        // console.log({ zone, section, id, designData });
        if (designData.selectedMaterial[zone]) {
          setDesignData((p) => ({
            ...p,
            selectedMaterial: {
              ...p.selectedMaterial,
              [zone]: p.selectedMaterial?.[zone]?.some(
                (v) =>
                  v.section == section && v.materialId == id && !v?.isDelete,
              )
                ? [
                    ...p.selectedMaterial?.[zone]?.filter(
                      (v) => !(v.section == section && v.materialId == id),
                    ),
                    {
                      section: section,
                      materialId: id,
                      isDelete: true,
                      quantity: quantity,
                      uom,
                      material: material,
                    },
                  ]
                : [
                    ...p.selectedMaterial?.[zone]?.filter(
                      (v) => !(v.section == section && v.materialId == id),
                    ),

                    {
                      section: section,
                      materialId: id,
                      quantity: quantity,
                      uom,
                      material: material,
                    },
                  ],
            },
          }));
        } else {
          // console.log("ELSE");
          setDesignData((p) => ({
            ...p,
            selectedMaterial: {
              ...p.selectedMaterial,
              [zone]: [
                {
                  section: section,
                  materialId: id,
                  quantity: quantity,
                  material: material,
                  uom: uom,
                },
              ],
            },
          }));
        }
      } catch (error) {
        console.error("Error adding material to project:", error);
      }
    },
    [filters, designData],
  );

  const SetDesignDataForExistingMaterials = useCallback(
    (projectId, projectName, selectedMaterial = {}) => {
      console.log(
        { projectId, projectName, selectedMaterial },
        "----------SETTING DESIGN DATA",
      );
      // return;
      setDesignData((p) => ({
        ...p,
        projectId: projectId,
        projectName: projectName,
        selectedMaterial: selectedMaterial,
      }));
    },
    [],
  );
  console.log({ designData, stateDesignData: state?.designData, state });
  async function handleSaveMaterial() {
    let materialData = [];
    Object.keys(designData?.selectedMaterial).forEach((zone) => {
      // console.log(zone);
      // return;
      designData.selectedMaterial[zone].forEach((obj) => {
        if (obj?.isDelete) {
          materialData.push({
            zone: zone,
            section: obj.section,
            to: "",
            from: obj.materialId,
            quantity: obj?.quantity || 1,
            uom: obj?.uom || "",
          });
        } else {
          materialData.push({
            zone: zone,
            section: obj.section,
            to: obj.materialId,
            from: "",
            quantity: obj?.quantity || 1,
            uom: obj?.uom || "",
          });
        }
      });
    });
    console.log({ materialData });
    let materials = materialData
      .filter((v) => !!v?.to)
      .map((v) => ({
        materialId: v.to,
        zone: v.zone,
        section: v.section,
        quantity: v.quantity,
        uom: v.uom,
      }));
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/project-showcases/image-materials`,
        {
          projectId: designData?.projectId,
          imageMaterials: [
            {
              image: selectedProjectImage,
              materials: materials,
            },
          ],
        },
        getAxiosConfig(),
      );
      // return;
      // const { data } = await axios.put(
      //   `${process.env.REACT_APP_BACK_URL}/api/material/project-material/${designData?.projectId}`,
      //   {
      //     // Include the necessary data to update the material
      //     materialData,
      //   },
      //   getAxiosConfig(),
      // );
      // setIsSidebarOpen(false);

      setIsPublicView(true);
      // setDesignData({
      //   projectId: null,
      //   designVibe: null,
      //   selectedMaterial: {},
      //   projectName: null,
      // });
      toast.success("Material saved successfully");
    } catch (error) {
      console.error("Error saving material:", error);
      toast.error("Failed to save material");
    }
  }

  useEffect(() => {
    // Detect if actual filters changed vs just page increment
    const filterKey = JSON.stringify({
      areas,
      detailedFilter,
      newfilter,
      subFilter,
      aiRecommendations,
      materialPrice,
    });
    const isFilterChange =
      prevFilterKeyRef.current !== null &&
      prevFilterKeyRef.current !== filterKey;
    prevFilterKeyRef.current = filterKey;

    console.log("Filters changed:", {
      filters,
      val: !!designData.selectedMaterial[filters?.zone?.[0]],
      detailedFilter,
      areas,
      newfilter,
      subFilter,
      currPage,
      designData,
      aiRecommendations,
      Loading,
      aiImageLoading,
      materialPrice,
      isFilterChange,
    });

    if (aiImageLoading) return;

    // Filter changed → always fetch; abort controller cancels any in-flight request
    // Page change only → respect Loading/hasMore to avoid duplicate infinite-scroll fetches
    if (isFilterChange || (hasMore && !Loading)) {
      fetchMaterials();
    }
  }, [
    // !!designData.selectedMaterial[filters?.zone?.[0]],
    JSON.stringify(areas),
    JSON.stringify(detailedFilter),
    currPage,
    JSON.stringify(newfilter),
    JSON.stringify(subFilter),
    JSON.stringify(aiRecommendations),
    JSON.stringify(materialPrice),
    aiImageLoading,
  ]);
  useEffect(() => {
    if (location.state?.zone) {
      setFilters((prev) => ({
        ...prev,
        zone: [location.state.zone],
      }));
    } else {
      setProjectPopup([true, null]);
    }
  }, []);
  useEffect(() => {
    fetchMaterials(true);
  }, []);
  useEffect(() => {
    !isSidebarOpen && setFilteredMaterials(allMaterials);
    setDesignData(
      state?.designData || {
        projectId: null,
        designVibe: null,
        selectedMaterial: {},
        projectName: null,
      },
    );
    setFilters(
      state?.filters || {
        zone: [],
        section: [],
        material: [],
      },
    );
    setProjectSearch("");
  }, [isSidebarOpen]);

  let possibleOptions = useMemo(() => {
    return {
      zone: [
        "Board Room",
        "Breakout Area",
        "CEO Cabin",
        "Cafeteria",
        "Manager Cabin",
        "Meeting Room",
        "Open Office",
        "Pantry",
        "Reception",
        "Washroom",
      ],
      section: [
        "Paints",
        "Bathroom Fittings",
        "Lighting",
        "Flooring",
        "Furniture",
        "Tiles & Ceramics",
        "Stone & Marble",
        "Rugs & Carpets",
        "Modular",
        "Laminates",
      ],
      materialType: [
        ...new Set(allMaterials.map((v) => v.materialType).flat()),
      ],
    };
  }, [allMaterials]);

  const divClass = useMemo(() => {
    return `${
      isSidebarOpen && IS_SHOW_BAR ? "w-[calc(100%-364px)]" : "w-full"
    } transition-all duration-200  space-y-4 p-4 `;
  }, [isSidebarOpen]);
  console.log("LOADING", {
    firstPageLoading,
    aiImageLoading,
    Loading,
    filterloading: filterloading?.[0],
  });
  return (
    <>
      <div
        style={{
          backgroundImage: `url(${bannerInfo?.bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "30vh",
        }}
        className="flex flex-col gap-1.5 lg:gap-2 text-white text-lg sm:text-2xl lg:text-5xl font-bold items-center justify-center  "
      >
        <h2>{bannerInfo?.info?.[0]}</h2>
        <h2>{bannerInfo?.info?.[1]}</h2>
      </div>

      <div className="px-4 flex justify-end items-center gap-4 relative w-full">
        {aiRecommendations && aiRecommendations.length > 0 && (
          <div className="left-[380px] absolute flex items-center gap-1.5 bg-amber-50 border border-amber-300 text-amber-700 text-xs font-semibold px-2.5 py-1 rounded-full shadow-sm">
            <Icon icon="mdi:star" width={14} className="text-amber-500" />
            <span>Recommended Products</span>
          </div>
        )}
        {IS_SHOW_BAR && (
          <ShowBrandButton
            isViewBrand={isViewBrand}
            setIsViewBrand={setIsViewBrand}
          />
        )}
        {!IS_SHOW_BAR && (
          <AddMaterialButton
            onSuccess={() => {
              fetchMaterials();
              setRefetchFilter((p) => !p);
            }}
          />
        )}
        <p className="text-sm text-gray-600 my-2 sm:text-base md:my-3 text-right">
          Showing <span className="font-semibold text-gray-900">{1}</span>–
          <span className="font-semibold text-gray-900">
            {Math.min(currPage * 20, totalProducts)}
          </span>{" "}
          of{" "}
          <span className="font-semibold text-gray-900">{totalProducts}</span>{" "}
          products
        </p>
      </div>

      {!!firstPageLoading || aiImageLoading ? (
        <div className="mt-16 flex flex-col items-center justify-center gap-4">
          <Spinner colorScheme="teal" color="teal" size={"xl"} />
          {aiImageLoading ? (
            <div className="flex flex-col items-center gap-1 text-center">
              <p className="text-gray-700 font-semibold text-base">
                Finding the best products for you
              </p>
              <p className="text-gray-400 text-sm">
                Analysing your space and preferences...
              </p>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-1 text-center">
              <p className="text-gray-700 font-semibold text-base">
                Loading products
              </p>
              <p className="text-gray-400 text-sm">
                Fetching the latest materials...
              </p>
            </div>
          )}
        </div>
      ) : (
        <MaterialGrid
          showMoreInfo={isViewBrand.authorized}
          divClass={divClass}
          filteredMaterials={filteredMaterials}
          filters={filters}
          handleAddMaterialToProject={handleAddMaterialToProject}
          designData={designData}
          isSidebarOpen={IS_SHOW_BAR ? isSidebarOpen : false}
          isClientSelection={IS_SHOW_BAR}
          canClick={isSidebarOpen}
          isClickable={
            filters.zone.length === 0 || filters.section.length === 0
              ? false
              : true
          }
          aiRecommendations={aiRecommendations}
          isDelete={isDelete}
          afterDeleteCb={() => fetchMaterials()}
        />
      )}

      {Loading && !filterloading?.[0] && !firstPageLoading && (
        <div className="mt-4 text-center w-full">
          <Spinner colorScheme="teal" color="teal" size={"lg"} />
          Loading more materials...
        </div>
      )}
      {zonePopup?.[0] && (
        <div className="fixed inset-0 z-60 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 w-full max-w-md mx-4 overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-teal-500 to-teal-600 px-6 py-4">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-white">
                  Select Zones
                </h3>
              </div>
            </div>

            {/* Content */}
            <div className="px-6 py-6">
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">
                  Project: {projectPopup?.[1]?.title}
                </h4>
                <p className="text-gray-600 text-sm mb-4">
                  Select the zones where this material will be applied:
                </p>

                {/* Zone Selection */}
                <div className="space-y-3 max-h-60 overflow-y-auto">
                  {zonePopup?.[1]?.zones &&
                    zonePopup?.[1]?.zones?.length > 0 &&
                    zonePopup?.[1]?.zones?.map((zone, index) => (
                      <label
                        key={index}
                        className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors"
                      >
                        <input
                          type="checkbox"
                          checked={selectedZones.includes(zone)}
                          onChange={() => handleZoneSelection(zone)}
                          className="form-checkbox text-teal-600 rounded w-4 h-4 border-gray-300 focus:ring-teal-500"
                        />
                        <span className="text-gray-700 font-medium capitalize">
                          {zone.replace(/-/g, " ").replace(/_/g, " ")}
                        </span>
                      </label>
                    ))}
                </div>

                {zonePopup?.[1]?.zones?.length === 0 && (
                  <div className="text-center py-8">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <svg
                        className="w-8 h-8 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                        />
                      </svg>
                    </div>
                    <p className="text-gray-500">No zones available</p>
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setZonePopup([false, null]);
                    setSelectedZones([]);
                  }}
                  className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-4 rounded-xl transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                  Cancel
                </button>
                <button
                  onClick={() => {
                    // console.log(
                    //   "Selected Zones",
                    //   selectedZones,
                    //   "project",
                    //   projectPopup?.[1],
                    //   "material",
                    //   zonePopup?.[1],
                    // );
                    handleAddToProject(zonePopup?.[1]?._id, selectedZones);
                  }}
                  disabled={selectedZones.length === 0}
                  className="flex-1 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 disabled:from-gray-300 disabled:to-gray-400 text-white font-semibold py-3 px-4 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center gap-2 disabled:transform-none disabled:shadow-none"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Confirm ({selectedZones.length})
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {IS_SHOW_BAR && (
        <AiButton
          isOpen={isSidebarOpen}
          setIsOpen={setIsSidebarOpen}
          designData={designData}
          setDesignData={setDesignData}
          possibleOptions={possibleOptions} // all zones and sections
          filters={filters}
          setFilters={(val) => {
            setFilters(val);
          }}
          handleSaveMaterial={handleSaveMaterial}
          isPublicView={
            isPublicView ||
            (designData?.projectId &&
            Object.keys(designData?.selectedMaterial).length > 0
              ? true
              : false)
          }
          SetDesignDataForExistingMaterials={SetDesignDataForExistingMaterials}
          newFilter={newfilter}
          setNewFilter={(val) => {
            if (JSON.stringify(val) === JSON.stringify(newfilter)) return;
            // console.log("NEW FILTER VAL FROM AIBUTTON", val);

            setNewFilter(val);
            window.scrollTo(0, 0);
            setCurrPage(1);

            setHasMore(true);
            console.log("CHANGED FILTER LOADING TO TRUE");
          }}
          state={{
            designData,
            ...(state || {}),
            newfilter,
            filters,
            returnUrl: `${location.pathname}${location.search}`,
          }}
          handleStepBack={(from, to) => {
            console.log(from, to);
            setAiRecommendations([]);
            setFilters({
              zone: [],
              section: [],
              material: [],
            });
            // console.log("NEW FILTER VAL FROM STEP BACK", {});

            setNewFilter({});
          }}
          selectedProjectImage={selectedProjectImage}
          setSelectedProjectImage={setSelectedProjectImage}
          areas={areas}
          setAreas={setAreas}
          setAiRecommendations={setAiRecommendations}
          aiRecommendations={aiRecommendations}
          aiImageLoading={aiImageLoading}
          setAiImageLoading={setAiImageLoading}
          projectSearch={projectSearch}
          setProjectSearch={setProjectSearch}
        />
      )}
      <FilterBar
        filter={newfilter}
        subFilter={subFilter}
        setFilter={(val) => {
          // console.log("NEW FILTER VAL FROM FILTERBAR", val, newfilter);
          setNewFilter(val);
          // setSubFilter({});
          window.scrollTo(0, 0);
          setCurrPage(1);
          setHasMore(true);
          console.log("CHANGED FILTER LOADING TO TRUE");
          handleFilterLoading(true, "filterBar");
        }}
        clearSubFilter={() => setSubFilter({})}
        isSidebarOpen={IS_SHOW_BAR ? isSidebarOpen : false}
        setFilterLoading={(bool) => {
          handleFilterLoading(bool, "filterBar");
        }}
        refetchFilter={refetchFilter}
        materialPrice={materialPrice}
        setMaterialPrice={setMaterialPrice}
        setCurrPage={setCurrPage}
      >
        <SubFilterBar
          filter={newfilter}
          subFilter={subFilter}
          setSubFilter={(val) => {
            setSubFilter(val);
            window.scrollTo(0, 0);
            setCurrPage(1);
            setHasMore(true);
            console.log("CHANGED FILTER LOADING TO TRUE");
            handleFilterLoading(true, "subFilter");
          }}
          setFilterLoading={(bool) => {
            handleFilterLoading(bool, "subFilter");
          }}
        />
      </FilterBar>
    </>
  );
};

export const FilterOption = ({
  filters,
  setFilters,
  options,
  notShowAddMaterial = false,
}) => {
  const nav = useNavigate();
  const { isUser, onlyAdmins } = useRole();
  const AllFilters = [
    {
      label: "Zone",
      optionKey: "zone",
      options: options.zone.map((v) => ({ label: v, value: v })),
    },
    {
      label: "Section",
      optionKey: "section",
      options: options.section.map((v) => ({
        label: v,
        value: v,
      })),
    },
    {
      label: "Material",
      optionKey: "material",
      options: options.materialType.map((v) => ({
        label: v,
        value: v,
      })),
    },
  ];

  const handleFilterChange = (optionKey, selectedOptions) => {
    setFilters((prev) => ({
      ...prev,
      [optionKey]: selectedOptions
        ? selectedOptions.map((opt) => opt.value)
        : [],
    }));
  };

  return (
    <div
      className={`grid ${
        isUser || notShowAddMaterial ? "grid-cols-3" : "grid-cols-4"
      } gap-3`}
    >
      {AllFilters.map((val) => (
        <Select
          key={val.optionKey}
          placeholder={`Select ${val.label}`}
          options={val.options}
          isClearable
          isMulti
          value={val.options.filter((opt) =>
            filters[val.optionKey].includes(opt.value),
          )}
          onChange={(options) => handleFilterChange(val.optionKey, options)}
        />
      ))}
      {onlyAdmins && !notShowAddMaterial && (
        <PrimaryButton onClick={() => nav("add")}> Add Material</PrimaryButton>
      )}
    </div>
  );
};

// ============================================
// MaterialGrid with proper Masonry handling
// ============================================
const MaterialGrid = React.memo(
  ({
    divClass,
    filteredMaterials,
    filters,
    handleAddMaterialToProject,
    designData,
    isSidebarOpen,
    isClientSelection,
    isClickable,
    showMoreInfo = false,
    aiRecommendations = [],
    canClick,
    isDelete = false,
    afterDeleteCb = () => {},
  }) => {
    // Force Masonry to recalculate after new items are painted
    const [masonryKey, setMasonryKey] = useState(0);
    const prevLengthRef = useRef(filteredMaterials.length);

    useEffect(() => {
      // When new items are added, wait for them to render & paint,
      // then force Masonry to recalculate column distribution
      if (filteredMaterials.length !== prevLengthRef.current) {
        prevLengthRef.current = filteredMaterials.length;

        // requestAnimationFrame ensures DOM has painted
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setMasonryKey((k) => k + 1);
          });
        });
      }
    }, [filteredMaterials.length]);

    const selectedMaterials = useMemo(() => {
      if (filters?.zone?.length === 0 || filters?.section?.length === 0) {
        return [];
      }
      return (
        designData.selectedMaterial?.[filters.zone[0]]
          ?.filter(
            (v) => v.section === filters.section[0] && v?.isDelete !== true,
          )
          ?.map((v) => v.materialId) || []
      );
    }, [filters?.zone, filters?.section, designData.selectedMaterial]);

    if (filteredMaterials.length === 0) {
      return (
        <div className="flex justify-end">
          <div className={`${divClass}`}>
            <div className="text-center text-gray-500 text-lg py-20 w-full">
              No products found for selected filters.
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="flex justify-end">
        <div className={`${divClass}`}>
          <ResponsiveMasonry
            columnsCountBreakPoints={
              isSidebarOpen
                ? { 300: 1, 990: 2, 1300: 3, 1610: 4, 1800: 5 }
                : { 300: 1, 626: 2, 936: 3, 1246: 4, 1550: 5 }
            }
          >
            <Masonry
              // Key changes when sidebar toggles OR when items are added
              key={`${isSidebarOpen ? "open" : "closed"}-${masonryKey}`}
              gutter="16px"
              style={{ width: "100%" }}
            >
              {filteredMaterials.map((material, idx) => (
                <MaterialCard
                  key={material._id}
                  material={material}
                  selectedMaterials={selectedMaterials}
                  handleAddMaterialToProject={handleAddMaterialToProject}
                  isSidebarOpen={isSidebarOpen}
                  isClientSelection={isClientSelection}
                  isClickable={isClickable}
                  canClick={canClick}
                  showMoreInfo={showMoreInfo}
                  isRecommended={aiRecommendations.includes(material._id)}
                  isDelete={isDelete}
                  afterDeleteCb={afterDeleteCb}
                />
              ))}
            </Masonry>
          </ResponsiveMasonry>
        </div>
      </div>
    );
  },
);

export default MaterialFilter;
